import React from 'react';
import { stringify } from 'query-string';

import config from 'config';
import Api from 'entities/api';

interface ExportLinkProps {
  deedType: string;
  searchTerm: string;
  organizationId: string;
  deedTypeForDisplay: string;
}

const ExportLink = ({
  deedType,
  searchTerm,
  organizationId,
  deedTypeForDisplay,
}: ExportLinkProps) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events
  <a
    style={{ outline: 'none' }}
    onClick={async (event) => {
      const a = event.target.tagName === 'A' ? event.target : event.target.parentElement;

      if (!a.href) {
        const queryStr = stringify(
          {
            type: deedType,
            search: searchTerm,
          },
          {
            arrayFormat: 'comma',
            skipEmptyString: true,
            skipNull: true,
          }
        );
        const response = await fetch(
          `${config.apiUrl}/api/organizations/${organizationId}/deeds/export?${queryStr}`,
          {
            method: 'GET',
            headers: {
              Authorization: Api.defaultHeaders.Authorization,
            },
          }
        );

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = `${deedType.toLowerCase()}-deeds.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.removeAttribute('href');
      }
    }}
    role="button"
    tabIndex={0}
    title={`Export ${deedTypeForDisplay}s`}
  >
    Export
  </a>
);

export default ExportLink;
